<template>
  <div>
    <modal name="modal-courier-register" :width="520">
      <header class="modal-header center-md center-xs py15 px65 h3 sans-serif weight-700 bg-cl-secondary flex">
        <span>{{ $t('Registration') }}</span>
        <i slot="close" class="modal-close material-icons p15 cl-bg-tertiary" @click="close" data-testid="closeModalButton">
          close
        </i>
      </header>
      <div class="modal-content">
        <!-- Content -->
        <div class="content-list-item-block">
          <!-- Description -->
          <div class="content-list-item-block-content-description"
               ref="description"
          ></div> <!-- Тут може бути додаткова інформація з порадами, як заповнювати форму заявки. -->
          <!---->

          <!-- Form -->
          <form @submit.prevent="addResume" novalidate>
            <div class="content-list-item-block-content isActive">
              <div class="content-list-item-block-content-form isActive"
                   ref="form"
              >
                <!-- Location field -->
                <base-select
                  name="locations_select"
                  id="locations_select"
                  class="content-list-item-block-content-form-field px10 border-box brdr-cl-primary brdr-1 content-list-item-block-content-form-field-select"
                  :options="listLocations"
                  :selected="selectedLocation"
                  :placeholder="$t('City *')"
                  :validations="[{
                                  condition: !$v.selectedLocation.required && $v.selectedLocation.$error,
                                  text: $t('Field is required')
                                }]"
                  v-model="selectedLocation"
                >
                </base-select>
                <!---->

                <!-- Firstname field -->
                <base-input class="base-input-small content-list-item-block-content-form-field"
                            type="text"
                            :placeholder="`${$t('First name')} *`"
                            :maxlength="50"
                            :validations="[
                                {
                                  condition: !$v.firstname.required && $v.firstname.$error,
                                  text: $t('Field is required')
                                },
                                {
                                  condition: !$v.firstname.minLength,
                                  text: $t('First name must have at least 2 letters.')
                                }
                              ]"
                            v-model.trim="firstname"
                />
                <!---->

                <!-- Lastname field -->
                <base-input class="base-input-small content-list-item-block-content-form-field"
                            type="text"
                            :placeholder="`${$t('Last name')} *`"
                            :maxlength="50"
                            :validations="[
                                {
                                  condition: !$v.lastname.required && $v.lastname.$error,
                                  text: $t('Field is required')
                                },
                                {
                                  condition: !$v.lastname.minLength,
                                  text: $t('Last name must have at least 2 letters.')
                                }
                              ]"
                            v-model.trim="lastname"
                />
                <!---->

                <!-- Email address field -->
                <base-input class="base-input-small content-list-item-block-content-form-field"
                            type="email"
                            :placeholder="`${$t('Email address')} *`"
                            :validations="[
                                {
                                  condition: !$v.email.required && $v.email.$error,
                                  text: $t('Field is required')
                                },
                                {
                                  condition: !$v.email.email,
                                  text: $t('Please provide valid e-mail address.')
                                }
                              ]"
                            v-model.trim="email"
                />
                <!---->

                <!-- Phone number field -->
                <base-input class="base-input-small content-list-item-block-content-form-field"
                            type="text"
                            :placeholder="$t('Phone Number *')"
                            :mask="{
                                mask: '+38(999)-999-9999',
                                showMaskOnHover: false,
                                autoUnmask: true
                              }"
                            :validations="[
                                {
                                  condition: $v.phone.$error && !$v.phone.required,
                                  text: $t('Field is required.')
                                },
                                {
                                  condition: $v.phone.$error && !$v.phone.minLength,
                                  text: $t('Incorrect type of number')
                                },
                                {
                                  condition: $v.phone.$error && !$v.phone.incorrectOperatorCodeWithTwo0,
                                  text: $t('Operator code cannot start with 00')
                                },
                                {
                                  condition: $v.phone.$error && !$v.phone.incorrectOperatorCode && $v.phone.required,
                                  text: $t('Operator code must start with 0')
                                }
                              ]"
                            v-model.trim="phone"
                />
                <!---->

                <!-- Password field -->
                <base-input class="base-input-small content-list-item-block-content-form-field"
                            type="password"
                            autocomplete="new-password"
                            :placeholder="`${$t('Desired password')} *`"
                            :minlength="8"
                            :maxlength="50"
                            :validations="[
                                {
                                  condition: !$v.password.required && $v.password.$error,
                                  text: $t('Field is required')
                                },
                                {
                                  condition: !$v.password.minLength,
                                  text: $t('The password needs at least 8 characters. Create a new password and try again.')
                                }
                              ]"
                            v-model.trim="password"
                />
                <!---->

                <!-- Desired Password field -->
                <base-input class="base-input-small content-list-item-block-content-form-field"
                            type="password"
                            autocomplete="new-password"
                            :placeholder="`${$t('Repeat desired password')} *`"
                            :minlength="8"
                            :maxlength="50"
                            :validations="[
                                {
                                  condition: !$v.rePassword.required && $v.rePassword.$error,
                                  text: $t('Field is required')
                                },
                                {
                                  condition:!$v.rePassword.sameAsPassword,
                                  text: $t('Passwords must be identical.')
                                }
                              ]"
                            v-model.trim="rePassword"
                />
                <!---->

                <!-- Transport field -->
                <base-select
                  name="transport_select"
                  id="transport_select"
                  class="content-list-item-block-content-form-field px10 border-box brdr-cl-primary brdr-1 content-list-item-block-content-form-field-select"
                  :options="listTransport"
                  :selected="selectedTransport"
                  :placeholder="$t('Transport *')"
                  :validations="[{
                                  condition: !$v.selectedTransport.required && $v.selectedTransport.$error,
                                  text: $t('Field is required')
                                }]"
                  v-model="selectedTransport"
                >
                </base-select>
                <!---->
              </div>
              <!---->
            </div>
            <div class="content-list-item-block-footer">
              <!-- Attach file -->
              <div class="content-list-item-block-footer-file">
                <a class="content-list-item-block-content-form-file-title no-underline"
                   @click="$refs.fileInput.click()"
                > {{ $t('Attach resume') }} </a>
                <input type="file"
                       hidden
                       class="content-list-item-block-content-form-file-field"
                       ref="fileInput"
                       accept=".doc, .docs, .pdf, .png"
                       @change="uploadFile"
                >
                <span class="content-list-item-block-content-form-file-text"> {{ fileName }} </span>
              </div>
              <!---->

              <base-checkbox
                  class="mb10"
                  id="terms"
                  v-model="conditions"
                  @blur="$v.conditions.$reset()"
                  @change="$v.conditions.$touch()"
                  :validations="[{
                    condition: !$v.conditions.required && $v.conditions.$error,
                    text: $t('You must accept the terms and conditions.')
                  }]"
              >
                {{ $t('I agree to') }}
                <span class="link pointer" @click.prevent="openTermModal">
                 {{ $t('Terms and conditions') }}
                </span>
              </base-checkbox>
              <button-full
                  class="content-list-item-block-footer-btn"
                  :disabled="isCourierEnrollment"
                  type="submit">
                {{ $t('Send') }}
              </button-full>
            </div>
          </form>
        </div>
      </div>
    </modal>
    <modal-terms-of-use :showModal="showModal" />
  </div>
</template>

<script>
import Modal from 'theme/components/core/Modal'
import {email, minLength, required, sameAs} from "vuelidate/lib/validators";
import BaseInput from 'theme/components/core/blocks/Form/BaseInput'
import ButtonFull from 'theme/components/theme/ButtonFull'
import BaseCheckbox from 'theme/components/core/blocks/Form/BaseCheckbox'
import BaseSelect from 'theme/components/core/blocks/Form/BaseSelect'
import ModalTermsOfUse from "../../../core/blocks/Checkout/ModalTermsOfUse";

// Phone number validation methods
const incorrectOperatorCode = (value, vm) => (value.charAt(0) === '0');
const incorrectOperatorCodeWithTwo0 = (value, vm) => (value.charAt(1) !== '0');

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'CourierRegisterForm',

  components: {
    Modal,
    BaseInput,
    ButtonFull,
    BaseCheckbox,
    BaseSelect,
    ModalTermsOfUse
  },

  data () {
    return {
      // Form vars
      firstname: '',
      lastname: '',
      phone: '',
      email: '',
      file: null,
      fileName: '',
      password: '',
      rePassword: '',
      selectedLocation: '',
      selectedTransport: '',
      conditions: false,
      showModal: false
    }
  },

  async mounted () {
    this.$bus.$emit('modal-show', 'modal-courier-register')
    this.selectedLocation = !this.currentLocation || typeof this.currentLocation === 'undefined' || typeof this.currentLocation === undefined ? 'ternopil' : this.currentLocation.code
    if (this.transport && this.transport.length) {
      this.selectedTransport = this.transport && this.transport.length ? this.transport[0].id.toString() : ''
    } else {
      await this.loadActiveTransport().then(() => {
        this.selectedTransport = this.transport && this.transport.length ? this.transport[0].id.toString() : ''
      })
    }
  },

  computed: {
    ...mapGetters({
      locations: 'locations/getLocations',
      currentLocation: 'locations/getActiveLocation',
      transport: 'transport/getTransport',
      courierEnrollment: 'configs/getConfigCourierEnrollment'
    }),
    listLocations () {
      return this.locations.map(location => {
        return  {
          value: location.code,
          label: location.name
        }
      })
    },
    listTransport () {
      return this.transport.map(trans => {
        return  {
          value: trans.id.toString(),
          label: trans.name
        }
      })
    },
    isCourierEnrollment() {
      let isPresent = this.courierEnrollment.find(meta => meta.key === 'disable_courier_enrollment')
      return isPresent ? isPresent.value : false
    }
  },

  methods: {
    ...mapActions({
      loadLocations: 'locations/loadLocations',
      loadActiveTransport: 'transport/loadActiveTransport',
      sendApplication: 'vacancies/createApplicant'
    }),

    close () {
      this.clearAllFormFields()
      this.$bus.$emit('modal-hide', 'modal-courier-register')
      if (this.$route.params.hasOwnProperty('become_courier')) this.$router.replace({params: { become_courier: null }})
    },

    // Upload file in vacancy resume
    uploadFile (event) {
      const applyFile = event.target.files[0]
      if (applyFile !== undefined) {
        this.file = event.target.files[0]
        this.fileName = applyFile.name
      }
    },

    // Add new resume
    async addResume () {
      if (this.$v.$invalid) {
        this.$v.$touch()
        this.$store.dispatch('notification/spawnNotification', {
          type: 'error',
          message: this.$t('Please fix the validation errors'),
          action1: { label: this.$t('OK') }
        })
        return
      }

      let payload = {
        userPersonalData: {
          user: {
            location: this.selectedLocation,
            firstname: this.firstname,
            lastname: this.lastname,
            telephone: this.phone,
            email: this.email,
            password: this.password,
            repassword: this.rePassword,
            transport: this.selectedTransport
          },
          file: this.file,
          fileName: this.fileName
        }
      }
      await this.sendApplication(payload).then(res => {
        if (res.result.status && res.result.status === 'error') {
          let message = res.result.message.replace(this.email, '{email}');
          this.$store.dispatch('notification/spawnNotification', {
            type: 'error',
            message: this.$t(message, {email: this.email}),
            action1: { label: this.$t('OK') }
          })
        } else {
          this.onSuccesfulSubmission()
        }
        return res
      })

      this.clearAllFormFields()
      this.$bus.$emit('modal-hide', 'modal-courier-register')
    },

    onSuccesfulSubmission () {
      this.$store.dispatch('notification/spawnNotification', {
        type: 'success',
        message: this.$t("Thank you for the registration. Wait for the operator's call and further instructions."),
        action1: { label: this.$t('OK') }
      })
    },

    // Clear all fields
    clearAllFormFields () {
      this.firstname = ''
      this.lastname = ''
      this.phone = ''
      this.email = ''
      this.password = ''
      this.rePassword = ''
      this.selectedLocation = ''
      this.selectedTransport = ''
      this.file = null
      this.fileName = ''
      this.conditions = false
      this.$v.$reset();
    },

    openTermModal () {
      this.$bus.$emit('modal-toggle', 'modal-terms')
      this.$bus.$emit('modal-in-modal')
      this.showModal = true
    },
  },

  validations: {
    selectedLocation: {
      required
    },
    lastname: {
      required,
      minLength: minLength(2)
    },
    firstname: {
      required,
      minLength: minLength(2)
    },
    email: {
      required,
      email
    },
    phone: {
      required,
      minLength: minLength(10),
      incorrectOperatorCode,
      incorrectOperatorCodeWithTwo0
    },
    password: {
      required,
      minLength: minLength(8)
    },
    rePassword: {
      required,
      sameAsPassword: sameAs('password')
    },
    selectedTransport: {
      required
    },
    conditions: {
      required
    }
  }
}
</script>

<style>
.link {
  color: #000;
  text-decoration: underline;
}
.select-wrapper.content-list-item-block-content-form-field select {
  border: none;
  width: 100%;
  border-radius: 0;
  background-color: transparent;
  font-size: 18px;
  font-family: 'TTNorms Regular', sans-serif;
}
</style>
<style lang="scss" scoped>
.modal-content {
  max-height: 770px;
  .content-list-item-block {
    height: 100%;
    .content-list-item-block-content.isActive {
      max-height: 50vh;
      .content-list-item-block-content-form.isActive {
        max-height: 50vh;
      }
    }
    .content-list-item-block-footer {
      position:relative;
      left:0px;
      bottom:0px;
      height:130px;
      width:100%;
      &-file {
        width: 100%;
        height: 30px;
        margin-bottom: 10px;

        display: flex;
        justify-content: space-between;
        align-items: center;

        @media only screen and (max-width: 576px) {
          height: auto;
          margin-bottom: 0px;
          flex-direction: column;
          align-items: flex-start;
          justify-content: flex-start;
        }

        &-title {
          padding: 8px 0 8px 40px;
          position: relative;

          color: #11bb2e;
          font-size: 14px;
          font-weight: 400;

          &:hover {
            cursor: pointer;
            text-decoration: underline;
          }

          &:before {
            width: 30px;
            height: 30px;
            margin: auto;

            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            content: '';

            background-image: url('../../../../assets/static/vacancies/folder.png');
            background-position: center;
            background-size: 14px 17px;
            background-repeat: no-repeat;

            background-color: #fff;
            border-radius: 50%;
          }
        }

        &-field {
          display: none;
        }

        &-text {
          width: 150px;

          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;

          @media only screen and (max-width: 576px) {
            width: 100%;
            margin-top: 10px;
          }
        }
      }
      &-btn {
        width: auto;
        margin: 10px auto;
        min-height: 40px;
        padding: 13px 107px 13px 135px;
        align-self: center;
        color: #fff;
        font-size: 12px;
        font-weight: 600;
        background-image: url('../../../../assets/static/vacancies/circle-correct.png');
        background-position: 105px center;
        background-size: 22px;
        background-repeat: no-repeat;
        background-color: #11bb2e;
        border: none;
        border-radius: 5px;
        outline: none;
        transition: .2s;
        @media only screen and (max-width: 576px) {
          width: 100%;
          padding: 13px 0;
          background-position: 10px center;
        }
        &:hover {
          cursor: pointer;
          background-color: rgba(17, 187, 46, 0.8);
        }
      }
    }
  }
}
.content-list-item {
  width: calc(100% / 2 - 10px);
  margin-right: 20px;
  margin-bottom: 20px;
  position: relative;

  @media only screen and (max-width: 768px) {
    width: 100%;
    margin-right: 0;
  }

  &:nth-child(even) {
    margin-right: 0;
  }

  /* Header */
  &-header {
    display: flex;
    align-items: flex-end;

    &-icon {
      width: 30px;
      height: 30px;

      display: flex;
      justify-content: center;
      align-items: center;

      background-color: #f5f5f5;
      border-top-left-radius: 25px;
      border-top-right-radius: 25px;

      &-image {
        width: 20px;
        height: 20px;
      }
    }

    &-title {
      margin: 0;
      padding: 8px 10px;

      color: #333;
      font-size: 16px;
      font-weight: 600;
    }
  }
  /* --- */

  /* Main container */
  &-block {
    padding: 20px;

    border-top-right-radius: 5px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    background-color: #f5f5f5;

    &-select {
      &-small {
        min-height: 3.5rem;
      }
    }

    &-btn {
      padding: 7px 22px 7px 40px;
      position: relative;

      color: #fff;
      font-size: 14px;
      font-weight: 600;

      background-color: #11bb2e;
      border-radius: 25px;
      border: none;
      outline: none;

      transition: .2s;

      &:hover {
        cursor: pointer;
        background-color: rgba(17, 187, 46, .8);
      }

      &.isActive:before {
        transform: rotate(180deg);
      }

      &:before {
        width: 30px;
        height: 30px;
        margin: auto;

        position: absolute;
        top: 0;
        left: -2px;
        bottom: 0;
        content: '';

        background-image: url('../../../../assets/static/vacancies/arrow.png');
        background-position: center;
        background-size: 16px;
        background-repeat: no-repeat;

        background-color: #fff;
        border-radius: 50%;

        transition: .2s;
      }
    }

    /* Content */
    &-content {
      padding-right: 20px;

      margin-bottom: 20px;
      transition: .2s ease-out;

      &.isActive {
        max-height: 400px;
        margin-top: 20px;

        overflow-x: hidden;
        overflow-y: scroll;
        opacity: 1;

        transition: .2s ease-in;
      }

      /* Scroll styles */
      &::-webkit-scrollbar {
        width: 8px;
      }

      &::-webkit-scrollbar-track {
        background: #e6e6e6;
      }

      &::-webkit-scrollbar-thumb {
        background: #11bb2e;
        border-radius: 5px;
      }

      &::-webkit-scrollbar-thumb:hover {
        background: rgba(#11bb2e, .5);
      }
      /* --- */

      &-description {
        margin-bottom: 20px;
        transition: .3s;

        ::v-deep p {
          margin: 0;
        }

        ::v-deep ul {
          margin: 0;
          padding: 0;
          list-style: none;

          li {
            margin-top: 6px;
            padding-left: 35px;

            position: relative;

            &:before {
              width: 23px;
              height: 23px;
              margin: auto;

              position: absolute;
              top: 0;
              left: 0;
              bottom: 0;
              content: '';

              background-image: url('../../../../assets/static/vacancies/correct.png');
              background-position: center;
              background-size: 10px 8px;
              background-repeat: no-repeat;

              background-color: #11bb2e;
              border-radius: 50%;
            }
          }
        }
      }

      &-btn {
        padding: 7px 22px 7px 40px;
        position: relative;

        color: #fff;
        font-size: 14px;
        font-weight: 600;

        background-color: #11bb2e;
        border-radius: 25px;
        border: none;
        outline: none;

        transition: .2s;
        &.isFixed {
          position: absolute;
          bottom: 10px;
        }
        &:hover {
          cursor: pointer;
          background-color: rgba(17, 187, 46, .8);
        }

        &:before {
          width: 30px;
          height: 30px;
          margin: auto;

          position: absolute;
          top: 0;
          left: -2px;
          bottom: 0;
          content: '';

          background-image: url('../../../../assets/static/vacancies/book.png');
          background-position: center;
          background-size: 14px 17px;
          background-repeat: no-repeat;

          background-color: #fff;
          border-radius: 50%;
        }
      }

      &-form {
        max-height: 0;
        //overflow: hidden;
        opacity: 0;

        display: flex;
        flex-direction: column;
        align-items: flex-start;

        transition: .2s ease-out;

        &.isActive {
          max-height: 300px;
          margin-top: -35px;
          padding-top: 60px;

          opacity: 1;

          transition: .2s ease-in;

          @media only screen and (max-width: 576px) {
            max-height: 360px;
          }
        }

        &-field {
          width: 100%;
          margin-bottom: 10px;

          &-select {
            background: #fff;
            border-radius: 5px;
            border-color: #bdbdbd;
            margin-bottom: 24px;
            &:hover {
              border-color: rgba(17, 187, 46, .8);
            }
          }
        }

        &-file {
          width: 100%;
          height: 30px;
          margin-bottom: 20px;

          display: flex;
          justify-content: space-between;
          align-items: center;

          @media only screen and (max-width: 576px) {
            height: auto;

            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
          }

          &-title {
            padding: 8px 0 8px 40px;
            position: relative;

            color: #11bb2e;
            font-size: 14px;
            font-weight: 400;

            &:hover {
              cursor: pointer;
              text-decoration: underline;
            }

            &:before {
              width: 30px;
              height: 30px;
              margin: auto;

              position: absolute;
              top: 0;
              left: 0;
              bottom: 0;
              content: '';

              background-image: url('../../../../assets/static/vacancies/folder.png');
              background-position: center;
              background-size: 14px 17px;
              background-repeat: no-repeat;

              background-color: #fff;
              border-radius: 50%;
            }
          }

          &-field {
            display: none;
          }

          &-text {
            width: 150px;

            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;

            @media only screen and (max-width: 576px) {
              width: 100%;
              margin-top: 10px;
            }
          }
        }

        &-btn {
          width: auto;
          margin-top: 10px;
          min-height: 40px;
          margin-bottom: 10px;
          padding: 13px 107px 13px 135px;

          align-self: center;

          color: #fff;
          font-size: 12px;
          font-weight: 600;

          background-image: url('../../../../assets/static/vacancies/circle-correct.png');
          background-position: 105px center;
          background-size: 22px;
          background-repeat: no-repeat;

          background-color: #11bb2e;
          border: none;
          border-radius: 5px;
          outline: none;

          transition: .2s;

          @media only screen and (max-width: 576px) {
            width: 100%;
            padding: 13px 0;
            background-position: 10px center;
          }

          &:hover {
            cursor: pointer;
            background-color: rgba(17, 187, 46, 0.8);
          }
        }
      }
    }
    /* --- */
  }
  /* --- */
}
</style>

